import { MESSENGER_MAX_CONTEXT_ATTACHMENTS_PER_MESSAGE } from '@/components/Messenger/shared/composer/messengerAttachmentLimits';

function isValidStoredContextItem(item: unknown): boolean {
  if (!item || typeof item !== 'object') return false;
  const o = item as { type?: string; id?: unknown; date?: unknown };
  if (o.type === 'project') return typeof o.id === 'string' && o.id.trim() !== '';
  if (o.type === 'session') {
    return (
      typeof o.id === 'string' &&
      o.id.trim() !== '' &&
      typeof o.date === 'string' &&
      o.date.trim() !== ''
    );
  }
  return false;
}

/**
 * Массив для POST при пересылке сообщения с проектом/сессией (как в `parseContextAttachmentsForInsert` на сервере).
 */
export function contextAttachmentsForForwardPayload(raw: unknown): unknown[] | undefined {
  if (raw == null || raw === '') return undefined;
  let arr: unknown = raw;
  if (typeof raw === 'string') {
    try {
      arr = JSON.parse(raw) as unknown;
    } catch {
      return undefined;
    }
  }
  if (!Array.isArray(arr) || arr.length === 0) return undefined;
  const valid = arr.filter(isValidStoredContextItem);
  if (valid.length === 0) return undefined;
  return valid.slice(0, MESSENGER_MAX_CONTEXT_ATTACHMENTS_PER_MESSAGE);
}
